module.exports = "<div class=\"toolPanrlWrapper\">\r\n  <div class=\"toolPositionWrapper\">\r\n      <p class=\"title\">Position tool:</p>\r\n      <p [ngClass]=\"{'titlee':tooglePosition.x}\">Position X: {{positionX}}</p>\r\n      <p [ngClass]=\"{'titlee':tooglePosition.y}\">Position Y: {{positionY}}</p>\r\n      <p [ngClass]=\"{'titlee':tooglePosition.z}\">Position Z: {{positionZ}}</p>\r\n  </div>\r\n</div>\r\n                  \r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/StartApp/welcome/start/simulator/panel-wrapper/mem/toolpanel/toolpanel.component.html
// module id = ./src/app/StartApp/welcome/start/simulator/panel-wrapper/mem/toolpanel/toolpanel.component.html
// module chunks = main